module.exports = __webpack_public_path__ + "img/full3-min.56c78fc7.png";